import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/routes';
import { AlertMessage, AuthProvider, ThemeProvider } from "./global-components/src/index";
import { AlertProvider } from './global-components/src/index';
import "./style.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./global-components/src/globals/vars.css"

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <div>
    <HelmetProvider>
    <BrowserRouter>
        <AlertProvider>
          <AuthProvider>
              <ThemeProvider> {/* Garantindo que ThemeProvider envolve tudo */}
                <AlertMessage />
                <AppRoutes />
              </ThemeProvider>
          </AuthProvider>
        </AlertProvider>
    </BrowserRouter>
  </HelmetProvider>
  </div>
);

